import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { LoginService } from '../login/login.service';
import { UserRight } from '../login/user.model';
import { map } from 'rxjs/operators';

export const HasRightsGuard = (route: ActivatedRouteSnapshot) => {
  const loginService = inject(LoginService);
  const router = inject(Router);
  return loginService.hasRights(route.data.rights as UserRight[]).pipe(
    map(hasRights => {
      if (!hasRights) {
        return router.createUrlTree(['/no-rights']);
      }
      return true;
    })
  );
};
